import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductinformationComponent } from './productinformation.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material';


const routes: Routes = [
  {
      path: '',
      component: ProductinformationComponent,
      data: {
          title: 'Product Information'
      }
  }
];
@NgModule({
  declarations: [ProductinformationComponent],
  imports: [
    BrowserModule,
    CommonModule,  
    SharedModule,
    ReactiveFormsModule,  
    FormsModule,
    MatRadioModule, 
    RouterModule.forChild(routes)
  ]
})
export class ProductinformationModule { }

